import { motion } from "framer-motion";
import { Eye, Heart, Target } from "lucide-react";

const coreValues = [
  {
    title: "Chất lượng vượt trội",
    description:
      "Mỗi website, hệ thống phần mềm hay chiến dịch Digital Marketing của TrioCore đều được xây dựng với tiêu chuẩn kỹ thuật cao, đảm bảo hiệu năng, bảo mật và khả năng sinh lời thực tế.",
  },
  {
    title: "Cam kết bền vững",
    description:
      "Chúng tôi xác định rõ trách nhiệm trong từng hạng mục triển khai, luôn minh bạch về chỉ số và đồng hành dài hạn cùng sự tăng trưởng của doanh nghiệp.",
  },
  {
    title: "Đội ngũ thực chiến",
    description:
      "Sở hữu đội ngũ kỹ sư phần mềm, chuyên viên tối ưu vận hành và chuyên gia Marketing am hiểu sâu sắc thị trường, làm việc theo quy trình tối ưu, gọn gàng.",
  },
  {
    title: "Giải pháp linh hoạt",
    description:
      "Không rập khuôn sản phẩm. TrioCore thiết kế giải pháp cá nhân hóa bám sát vào quy trình thực tế và ngân sách của từng mô hình kinh doanh.",
  },
  {
    title: "Minh bạch hiệu quả",
    description:
      "Cam kết triển khai đúng tiến độ, đo lường bằng số liệu thực như Leads, doanh thu và hiệu suất vận hành, đồng thời kiểm soát chi phí tối đa cho doanh nghiệp.",
  },
];

const SectionOrientation: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#fff8f8] to-white py-16 md:py-20">
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.94),rgba(255,246,246,0.98))]" />

      <div className="relative container mx-auto px-4">
        <div className="mx-auto max-w-[1180px]">
          <div className="mb-10 text-center md:mb-12">
            <span className="inline-flex items-center rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
              Triết lý hành động
            </span>
            <h2 className="mx-auto mt-5 max-w-[760px] text-[28px] font-semibold leading-[1.18] text-[#2f1a1a] sm:text-[32px] lg:text-[38px]">
              Triết Lý Hành Động & Cam Kết Khách Hàng
            </h2>
            <p className="mx-auto mt-4 max-w-[760px] text-[15px] leading-8 text-slate-600 sm:text-[16px]">
              TrioCore Solutions xây dựng nền tảng hợp tác dài hạn bằng tư duy thực chiến, minh
              bạch trong triển khai và tập trung vào giá trị đo lường được cho doanh nghiệp.
            </p>
          </div>

          <div className="grid gap-6 text-left lg:grid-cols-[1.18fr_0.82fr] lg:gap-8">
            <motion.article
              className="rounded-[28px] border border-red-100 bg-white/92 p-6 text-left shadow-[0_20px_60px_rgba(127,29,29,0.08)] backdrop-blur-sm sm:p-7 lg:p-8"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="mb-6 flex items-center gap-3 text-left">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#ef4444_0%,#b91c1c_100%)] text-white shadow-[0_10px_24px_rgba(220,38,38,0.18)]">
                  <Heart size={24}  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-[20px] font-semibold leading-tight text-[#2f1a1a] sm:text-[22px]">
                    Giá Trị Cốt Lõi
                  </h3>
                  <p className="mt-1 text-[14px] text-slate-500">
                    Hệ tiêu chuẩn TrioCore sử dụng trong mọi dự án triển khai.
                  </p>
                </div>
              </div>

              <div className="grid gap-4 text-left sm:grid-cols-2">
                {coreValues.map((item, index) => (
                  <div
                    key={item.title}
                    className={`rounded-[22px] border border-red-100 bg-[linear-gradient(180deg,#ffffff_0%,#fff8f8_100%)] p-4 text-left sm:p-5 ${
                      index === coreValues.length - 1 ? "sm:col-span-2" : ""
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-red-500" />
                      <div>
                        <h4 className="text-[16px] font-semibold text-[#2f1a1a] sm:text-[17px]">
                          {item.title}
                        </h4>
                        <p className="mt-2 text-[13.5px] leading-7 text-slate-600 sm:text-[14px]">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </motion.article>

            <div className="grid gap-6">
              <motion.article
                className="rounded-[28px] border border-red-100 bg-white/92 p-6 text-left shadow-[0_18px_44px_rgba(127,29,29,0.07)] backdrop-blur-sm sm:p-7"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.08 }}
                viewport={{ once: true }}
              >
                <div className="mb-5 flex items-center gap-3">
                  <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-red-50 text-red-600">
                    <Target size={22}  />
                  </div>
                  <h3 className="text-[22px] font-semibold text-[#2f1a1a]">Sứ Mệnh</h3>
                </div>

                <p className="text-[15px] font-medium italic leading-7 text-red-700">
                  "Đồng hành giải pháp – Song hành giá trị" là kim chỉ nam của chúng tôi.
                </p>
                <p className="mt-4 text-[14px] leading-7 text-slate-600">
                  TrioCore Solutions sinh ra để xóa bỏ rào cản công nghệ và marketing cho doanh
                  nghiệp. Chúng tôi cung cấp hệ sinh thái khép kín được thiết kế riêng biệt cho
                  từng chặng đường phát triển: từ các startup cần mô hình chuyển đổi nhanh, các
                  doanh nghiệp truyền thống cần số hóa danh mục và tối ưu vận hành, đến các tổ
                  chức cần hệ thống quản trị nội bộ phức tạp.
                </p>
              </motion.article>

              <motion.article
                className="rounded-[28px] border border-red-100 bg-white/92 p-6 text-left shadow-[0_18px_44px_rgba(127,29,29,0.07)] backdrop-blur-sm sm:p-7"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.16 }}
                viewport={{ once: true }}
              >
                <div className="mb-5 flex items-center gap-3">
                  <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-red-50 text-red-600">
                    <Eye size={22}  />
                  </div>
                  <h3 className="text-[22px] font-semibold text-[#2f1a1a]">Tầm Nhìn</h3>
                </div>

                <p className="text-[14px] leading-7 text-slate-600">
                  Trở thành bệ phóng công nghệ và chiến lược hàng đầu tại Việt Nam. Chúng tôi tin
                  rằng giải pháp số không đơn thuần là công cụ kỹ thuật, mà là nền tảng cốt lõi để
                  nâng cao năng lực cạnh tranh và tạo ra giá trị bứt phá dài hạn cho doanh nghiệp.
                </p>
              </motion.article>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionOrientation;
